import { UpdateInformationProps } from "components/BulkUpdateOptionalFieldsModal/types";
import React from "react";
import { useSelector } from "react-redux";
import { getBusinesses } from "selectors";
import { getIn, useFormikContext } from "formik";
import { getCheckboxFieldName } from "components/BulkUpdateOptionalFieldsModal/util";
import { pluralize } from "lib/pluralize";
import { UpdateInformationWrapper } from "components/BulkUpdateOptionalFieldsModal/UpdateInformationComponents";
import { EMPTY_ARRAY } from "lib";

export function UpdateInformationBusinessLabels(
  props: UpdateInformationProps,
): React.JSX.Element | null {
  const { field, modelIds, modelName } = props;
  const { fieldName } = field;

  const { values } = useFormikContext();
  const isSelected = getIn(values, getCheckboxFieldName(fieldName));
  const selectedLabelIds: string[] = getIn(values, fieldName) || EMPTY_ARRAY;
  const isRemove = fieldName === "removeLabels";

  const businesses: Record<string, Business> = useSelector(getBusinesses);

  const affectedCount = isRemove
    ? modelIds.filter(id =>
        selectedLabelIds.some(lId =>
          (businesses[id]?.labelIds || []).includes(lId),
        ),
      ).length
    : modelIds.length;

  const pronoun = selectedLabelIds.length === 1 ? "This" : "These";
  const noun = pluralize("label", selectedLabelIds.length);
  const verb = isRemove ? "removed from" : "added to";

  if (isSelected && selectedLabelIds.length) {
    return (
      <UpdateInformationWrapper>
        {pronoun} {noun} will be {verb} {affectedCount}{" "}
        {pluralize(modelName, affectedCount)}.
      </UpdateInformationWrapper>
    );
  }

  return null;
}
